(() => {
  const config = window.revieveSectionConfig;
  if (!config) return;

  function collectRoutineProductIds(routine) {
    var ids = [];
    if (!routine || typeof routine !== 'object') return ids;
    Object.keys(routine).forEach(function(priceGroup) {
      var list = routine[priceGroup];
      if (!Array.isArray(list)) return;
      list.forEach(function(p) {
        if (!p || !p.parent_id) return;
        var id = String(p.parent_id);
        if (ids.indexOf(id) === -1) ids.push(id);
      });
    });
    return ids;
  }

  function buildOmetriaPayload(advisorData) {
    var data = advisorData.data || {};
    var selections = data.activeSelections || {};
    var quizEmail = selections.email;
    if (!quizEmail) return null;

    var properties = {};

    if (Array.isArray(data.cvData)) {
      data.cvData.forEach(function(metric) {
        properties[metric.name] = metric.value;
      });
    }

    if (selections.skin_type) properties.skin_type = selections.skin_type;
    if (selections.gender) properties.gender = selections.gender;
    if (selections.age) properties.age = selections.age;
    if (Array.isArray(selections.skin_concerns)) {
      properties.skin_concerns = selections.skin_concerns.join(', ');
    }

    var location = selections.locationData && selections.locationData.location;
    var state = location && location.area;
    if (state && state !== 'undefined' && state !== 'Unknown') properties.state = state;

    var products = data.products || {};
    var amIds = collectRoutineProductIds(products.morning);
    if (amIds.length) properties.revieve_am_product_ids = amIds;

    var pmIds = collectRoutineProductIds(products.evening);
    if (pmIds.length) properties.revieve_pm_product_ids = pmIds;

    properties.analysis_date = new Date().toISOString();
    if (data.activeRoutine) properties.active_routine = data.activeRoutine;
    if (data.activePriceGroup) properties.active_price_group = data.activePriceGroup;

    return [{
      '@collection': config.ometriaCollection,
      'id': crypto.randomUUID(),
      'email': quizEmail,
      '@merge': true,
      'marketing_optin': 'EXPLICITLY_OPTEDIN',
      '@force_optin': true,
      'timestamp_subscribed': new Date().toISOString().replace(/\.\d{3}Z$/, '+00'),
      'properties': properties
    }];
  }

  const initRevieve = (sectionId) => {
    const sectionEl = document.querySelector(`#shopify-section-${sectionId}`);
    if (!sectionEl) return;

    const container = sectionEl.querySelector('[id^="revieve-container-"]');
    if (!container) return;

    container.innerHTML = '';

    const revieveConfig = {
      partner_id: config.partnerId,
      experienceId: config.experienceId,
      locale: window.theme.shop.locale,
      env: config.env,
      avoidCookies: false,
      delegateConsent: true,
    };

    if (config.displayMode === 'embedded') {
      revieveConfig.renderTo = container;
    }

    revieveConfig.onAddToCart = function(products) {
      var items = Array.isArray(products) ? products : [products];
      theme.cart.add(items.map(function(product) {
        return { id: product.id, quantity: 1 };
      }));
    };

    // Build the locale-aware checkout URL in the store (parent) context. The
    // Revieve experience runs in a cdn.revieve.com iframe, so a relative path or
    // the iframe's own location would send the user to
    // https://cdn.revieve.com/checkout (access denied). An absolute, store-origin
    // URL avoids that, and Shopify.routes.root carries the current market/locale
    // subfolder (e.g. "/en-ca/").
    var checkoutUrl = window.location.origin + Shopify.routes.root + 'checkout';

    revieveConfig.onCheckout = function() {
      // Navigate the top-level store window, breaking out of the Revieve iframe.
      try {
        window.top.location.href = checkoutUrl;
      } catch (e) {
        window.location.href = checkoutUrl;
      }
    };

    revieveConfig.onDisplayProducts = async function(history_id, products, revieveSessionId) {
      var advisorData = await Revieve.API.getAdvisorData();
      var payload = buildOmetriaPayload(advisorData);
      if (!payload || !config.datajetUrl) return;

      fetch(config.datajetUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(response) {
        if (!response.ok) {
          console.warn('[Revieve] Ometria push failed with status ' + response.status);
        }
      }).catch(function(error) {
        console.warn('[Revieve] Ometria push failed:', error);
      });
    };

    revieveConfig.onClickProduct = function(product, source) {
      var win = window.open(product.url, '_blank');
      if (win) win.focus();
    };

    const showRevieve = () => {
      Revieve.API.show();
    };

    if (typeof Revieve !== 'undefined') {
      Revieve.Init(revieveConfig, showRevieve);
    } else {
      var rv = document.createElement('script');
      rv.src = config.cdnUrl;
      rv.charset = 'utf-8';
      rv.type = 'text/javascript';
      rv.async = true;
      rv.onload = rv.onreadystatechange = function() {
        var rs = this.readyState;
        if (rs && rs !== 'complete' && rs !== 'loaded') return;

        if (typeof Revieve === 'undefined') {
          console.warn('[Revieve] Plugin failed to load.');
          return;
        }

        Revieve.Init(revieveConfig, showRevieve);
      };
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(rv, s);
    }
  };

  initRevieve(config.sectionId);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail.sectionId !== config.sectionId) return;
      initRevieve(e.detail.sectionId);
    });
  }
})();
